import B2 from "modules/ebiForms/definitions/B2";
import B3 from "modules/ebiForms/definitions/B3";
import B4 from "modules/ebiForms/definitions/B4";
import B7 from "modules/ebiForms/definitions/B7";
import B8 from "modules/ebiForms/definitions/B8";
import B11 from "modules/ebiForms/definitions/B11";
import B13 from "modules/ebiForms/definitions/B13";
import { IEbiFormDefinition } from "modules/ebiForms/typings";

/** Usługi i zezwolenia gminy: B2, B3, B4, B7, B8, B11, B13 (docs/magistrat/ebi-wnioski). */
const FORMS: IEbiFormDefinition[] = [B2, B3, B4, B7, B8, B11, B13];

export default FORMS;
